import { atom } from "jotai";

/**
 * Atom to track sidebar animation state
 * - 'preparingContainer': Triggers fade-in animation when sidebar is automatically opened
 * - 'fadeIn': Triggers fade-in animation when sidebar is automatically opened
 * - null: Normal state (no animation)
 */
export const sidebarAnimationAtom = atom<
  "preparingContainer" | "fadeIn" | null
>(null);

sidebarAnimationAtom.debugLabel = "sidebarAnimationAtom";
